import script from "./ContractDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ContractDetailView.vue?vue&type=style&index=0&id=2d118e23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d118e23"]])

export default __exports__